module.exports = __webpack_public_path__ + "static/img/defaultUser.7fec4bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defaultUser.png
// module id = /MMQ
// module chunks = 26